import {
  SET_CHAT_LOADING,
  SET_CHAT_SUCCESS,
  SET_CHAT_ERROR,
  SET_CONVO_LOADING,
  SET_CONVO_SUCCESS,
  SET_CONVO_ERROR,
  SET_RECENT_CONVO_LOADING,
  SET_RECENT_CONVO_SUCCESS,
  SET_RECENT_CONVO_ERROR
} from '../../Constants/action-types';

import {
  CHAT,
  GET_CONVERSATION,
  GET_RECENT_USER_CONVERSATION_ID
} from '../../functionality/networking';

import { callSignOut } from './signin-actions';

import { newsroomExampleChat, nonNewsroomExampleChat } from '../../Components/Chat/Sample';

// --- Action Creators ---

function setChatLoading() {
  return { type: SET_CHAT_LOADING };
}

function setChatSuccess(data) {
  return {
    type: SET_CHAT_SUCCESS,
    payload: data
  };
}

function setChatError() {
  return { type: SET_CHAT_ERROR };
}

function setConvoLoading() {
  return { type: SET_CONVO_LOADING };
}

function setConvoSuccess(conversation) {
  return {
    type: SET_CONVO_SUCCESS,
    payload: conversation
  };
}

function setConvoError() {
  return { type: SET_CONVO_ERROR };
}

function setRecentConvoLoading() {
  return { type: SET_RECENT_CONVO_LOADING };
}

function setRecentConvoSuccess(convoId) {
  return {
    type: SET_RECENT_CONVO_SUCCESS,
    payload: { conversation_id: convoId }
  };
}

function setRecentConvoError(error, newsroomExampleChat) {
  return {
    type: SET_RECENT_CONVO_ERROR,
    error: error,
    newsroomExampleChat: newsroomExampleChat
  };
}

// --- Async API Call Actions ---

export function sendChatMessage(message, conversation_id = null, email, token) {
  return (dispatch) => {
    dispatch(setChatLoading());

    return fetch(CHAT, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        token,
        message,
        ...(conversation_id ? { conversation_id } : {})
      })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.completion && data.conversation_id) {
          dispatch(setChatSuccess(data));
        } else if (data.error === '401 Unauthorized: Expired token') {
          window.localStorage.clear();
          dispatch(callSignOut());
          window.location.replace('/');
        } else {
          dispatch(setChatError());
        }
      })
      .catch(() => dispatch(setChatError()));
  };
}

export function fetchConversation(conversation_id, email, token) {
  return (dispatch, getState) => {
    dispatch(setConvoLoading());

    return fetch(GET_CONVERSATION, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        token,
        conversation_id
      })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.messages) {
          const { signInReducer } = getState();
          const { isLoggedin } = signInReducer;
          const exampleChat =
            isLoggedin && JSON.parse(localStorage.getItem('userData'))?.isNewsroom === true
              ? newsroomExampleChat
              : isLoggedin && JSON.parse(localStorage.getItem('userData'))?.isNewsroom === false
              ? nonNewsroomExampleChat
              : '';
          const combinedChat = exampleChat.concat(data.messages);
          dispatch(setConvoSuccess(combinedChat));
        } else {
          dispatch(setConvoError());
        }
      })
      .catch(() => dispatch(setConvoError()));
  };
}

export function fetchRecentUserConversationId(email, token) {
  return (dispatch, getState) => {
    dispatch(setRecentConvoLoading());

    return fetch(GET_RECENT_USER_CONVERSATION_ID, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        token
      })
    })
      .then((res) => {
        if (res.status === 404) {
          const { signInReducer } = getState();
          const { isLoggedin } = signInReducer;
          const exampleChat =
            isLoggedin && JSON.parse(localStorage.getItem('userData'))?.isNewsroom === true
              ? newsroomExampleChat
              : isLoggedin && JSON.parse(localStorage.getItem('userData'))?.isNewsroom === false
              ? nonNewsroomExampleChat
              : '';
          return dispatch(setRecentConvoError(404, exampleChat));
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.conversation_id) {
          dispatch(setRecentConvoSuccess(data.conversation_id));
        } else {
          dispatch(setRecentConvoError());
        }
      })
      .catch(() => {
        // dispatch(setRecentConvoError());
      });
  };
}
